import { useApplicationContext } from 'components/hooks/UseApplicationContext';
import { useLocation } from 'react-router';

enum SgefServicesEnum {
    SGM_SGEF_QUOTATION = 'SGM_SGEF_QUOTATION',
    SGM_CLIENT_PORTFOLIO = 'SGM_CLIENT_PORTFOLIO',
    SGM_SGEF_INVENTORY = 'SGM_SGEF_INVENTORY',
    SGM_SGEF_REPORTING = 'SGM_SGEF_REPORTING',
}

export const isSgefServices = (applicationName: string) => {
    return Object.values(SgefServicesEnum).some(
        (service) => service.toLowerCase() === applicationName.toLowerCase(),
    );
};

export const useGetMode = () => {
    const { hasOnlyB2b2cAccess } = useApplicationContext();
    const { pathname } = useLocation();
    const applicationName = pathname.replace('/disclaimer/page/', '').split('/')[0];

    if (isSgefServices(applicationName)) {
        return 'sgef';
    }
    if (hasOnlyB2b2cAccess) {
        return 'b2b2c';
    }
    return 'sg-markets';
};